"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrichSalesposter = void 0;
/**
 * Enriches the salesposter html links with the correct parameters
 * @returns StructuredResponse with the updated html
 */
var enrichSalesposter = function (_a) {
    var searchParams = _a.searchParams, returnUrl = _a.returnUrl, structuredResponse = _a.structuredResponse;
    var html = structuredResponse.html;
    searchParams.toString();
    var encodedCanonicalUrl = encodeURIComponent(returnUrl);
    var searchParamString = "&".concat(searchParams.toString());
    var updatedHtml = html.replace(/{{redirect_uri_url_encoded}}/gi, encodedCanonicalUrl + searchParamString);
    return __assign(__assign({}, structuredResponse), { html: updatedHtml });
};
exports.enrichSalesposter = enrichSalesposter;
//# sourceMappingURL=enrich-salesposter.js.map